<template lang="pug">
  .side-container__block.courses-side-folder-container.-new-folder-
    .side-container__header
      p.side-container__title
        | {{asideData.title}}
      p.side-container__subtitle
        | {{asideData.subtitle}}
    .side-container__body
      .side-container__block
        .side-container__block-item
          UiInput(
            title="Папка"
            v-model="folder.name"
            placeholder="Папка скорость"
            :error="$v.$dirty && !$v.folder.name.required"
            :popup="validPopup(!$v.folder.name.required, 'Обязательное поле')"
            @input="compare"
          )
        .side-container__block-item
          UiInput(
            title="Описание"
            v-model="folder.description"
            placeholder="Описание папки"
            @input="compare"
          )
        .side-container__block-item
          UiDropAsideImage(
            v-model="folder.img"
            dragText="Загрузите обложку для веб"
            @deleteImage="addImageToDelete"
            @input="compare"
          )
      .side-container__block
        .side-container__block-item
          UiDropAsideImage(
            v-model="folder.coverImg"
            dragText="Загрузите обложку для моб"
            buttonText="Загрузить (290х190 или 420х190)"
            @deleteImage="addImageToDelete"
            @input="compare"
          )
      .side-container__block
        .side-container-buttons
          //UiButton.-light-.-full-()
            | Сохранить и создать курс
          UiButton(@click="save")
            | Сохранить и выйти


</template>

<script>
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import validMixin from '@/mixins/validMixin';

export default {
  mixins: [validMixin],
  props: {
    asideObject: {
      type: Object,
      default: () => ({
        aside: {
          data: {
            name: '',
            folder: {}
          },
          meta: {}
        }
      })
    }
  },
  data: () => ({
    initialFields: {
      name: '',
      description: '',
      img: null,
      coverImg: null
    },
    folder: {},
    folderBackup: {},
    imagesToDelete: [],
    dataToSend: {}
  }),
  computed: {
    asideData() {
      return this.asideObject.aside ? this.asideObject.aside.data : {};
    }
  },
  mounted() {
    this.setFolderData();
  },
  methods: {
    ...mapActions('asides', ['closeAside', 'updateAsideMetaPath']),

    setFolderData() {
      if (this.asideData.folder) {
        this.folder = {
          ...this.initialFields,
          ...this.asideData.folder
        };
        this.folderBackup = _.cloneDeep(this.folder);
      }
    },
    addImageToDelete(file) {
      // Картинки не удаляются, пока не будет сохранены изменения
      if (file.id) {
        this.imagesToDelete.push(file);
      }
    },
    close() {
      this.$store.dispatch('asides/closeAside', {
        name: this.asideObject.aside.data.name
      });
    },
    compare() {
      // Проверка на изменения в эсайде для показа попапа при закрытии без сохранения
      if (
        !_.isEqual(this.folder, this.folderBackup) &&
        !this.asideObject.aside.meta.hasChanges
      ) {
        this.updateAsideMetaPath({
          asideIndex: this.asideObject.asideIndex,
          path: 'hasChanges',
          value: true
        });
      } else if (
        _.isEqual(this.folder, this.folderBackup) &&
        this.asideObject.aside.meta.hasChanges
      ) {
        this.updateAsideMetaPath({
          asideIndex: this.asideObject.asideIndex,
          path: 'hasChanges',
          value: false
        });
      }
    },
    async save() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      let hasErrors;
      let apiResponse;

      // Если есть изменения
      if (this.asideObject.aside.meta.hasChanges) {
        // Валидация пройдена. Процесс сохранения и преобразования данных

        // Показываем лоадер
        this.updateAsideMetaPath({
          asideIndex: this.asideObject.asideIndex,
          path: 'showLoader',
          value: true
        });

        this.dataToSend = _.cloneDeep(this.folder);
        try {
          // Удаляем картинки
          if (this.imagesToDelete.length) {
            this.deleteImages();
          }

          // Проверяем, есть ли новые картинки и загружаем их, чтобы получить id
          await this.sendImages();
        } catch (e) {
          console.warn(e);
          hasErrors = true;
        }

        // Проверка картинок, с бэка приходит пустой массив, а отправлять надо нулл или id
        if (this.dataToSend.img !== null && this.dataToSend.img.id) {
          this.dataToSend.img = this.dataToSend.img.id;
        }
        if (this.dataToSend.coverImg !== null && this.dataToSend.coverImg.id) {
          this.dataToSend.coverImg = this.dataToSend.coverImg.id;
        }

        // Если новая папка
        if (!this.dataToSend.id) {
          apiResponse = await this.$store.dispatch(
            'coursesFolder/createFolder',
            { folder: this.dataToSend }
          );
          // Если папка уже существет
        } else if (this.dataToSend.id) {
          apiResponse = await this.$store.dispatch('coursesFolder/editFolder', {
            folder: this.dataToSend
          });
        }

        // Подгружаем все папки, если получилось создать новую папку
        if (apiResponse === 'success') {
          await this.$store.dispatch('courses/getFolders');
        }
      }

      // Убираем ладер и закрываем эсайд
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'hasChanges',
        value: false
      });
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: false
      });
      if (!hasErrors) {
        this.closeAside({ name: this.asideObject.aside.data.name });
      }
    },
    deleteImages() {
      // TODO: удаление картинок, но я не нашел урла для удаления по id
      this.imagesToDelete = [];
    },
    async sendImages() {
      if (
        this.dataToSend.img &&
        !this.dataToSend.img.id &&
        this.dataToSend.img.name !== undefined
      ) {
        const formData = new FormData();
        formData.append('file', this.dataToSend.img);
        const res = await this.$store.dispatch('ajax/uploadImage', {
          formData
        });
        if (res) {
          this.dataToSend.img = res.id;
        }
      }

      if (
        this.dataToSend.coverImg &&
        !this.dataToSend.coverImg.id &&
        this.dataToSend.coverImg.name !== undefined
      ) {
        const formData = new FormData();
        formData.append('file', this.dataToSend.coverImg);
        const res = await this.$store.dispatch('ajax/uploadImage', {
          formData
        });
        if (res) {
          this.dataToSend.coverImg = res.id;
        }
      }
    }
  },
  validations: {
    folder: {
      name: { required }
    }
  }
};
</script>
